import React, { Component } from 'react';
import Header from './Header/Header'
import ProposalForm from '../../Forms/ProposalForm/ProposalForm'
import $ from 'jquery';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import API_Config from '../../API_Config';
import {Link} from 'react-router-dom';

class CustomResearch extends Component {
    constructor(props) {
        super(props);

    }
    render() {
        return (
            <div>
                <Header />
                <section class="ovrfl">
                    <div class="container">
                        <div class="row breadcrumb text-center trght">
                            <div class="col-md-12">
                                <span><Link to="/">Home</Link></span> <i class="fa fa-angle-right"></i>
                                <span>Methodology </span>
                            </div>
                        </div>
                        <div class="row cust_pad">
                            <div class="panel-group" id="accordion">

                                <div class="panel panel-default">
                                    <div class="panel-heading">
                    <span class="panel-title">
                    <h3>Industry Activities and Impact Analysis</h3>
                    <p>The second biggest player has acquired 3 companies, one each from Japan, India and China.How would it impact the industry dynamic

                      </p>
                      <a data-toggle="collapse" data-parent="#accordion" href="#collapse1" class="knowmore">Know More</a>
                    </span>
                                    </div>
                                    <div id="collapse1" class="panel-collapse collapse">
                                        <div class="panel-body">
                                            <div class="col-md-8 custo_bg">
                                                <ul class="ul_qu">
                                                    <li>  I would like to launch my product in the Asia-Pacific Market. What would be my target market size and how is its growth over the years?  	</li>
                                                    <li> In Asia-Pacific, which is the country with maximum targetabl
                                                        e market that has got least friction in terms of regulation and compliance.
                                                    </li>
                                                    <li> Is a market with healthy growth the place to be? What about competition?</li>
                                                    <li> I would like to launch my product in the Asia-Pacific Market. What would be my target market size and how is its growth over the years?  </li>
                                                    <li> In Asia-Pacific, which is the country with maximum targetable market that has got least friction in terms of regulation and compliance.
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="col-md-4 flash_sidebg">
                                                <h4>
                                                    Ask for a Proposal Today</h4>
                                                <div class="cust_form_bg">
                                                    <div class="new_form_req" id="new_custom">
                                                        <div class="group">
                                                            <input type="text" name="name" id="name1"></input>
                                                                <span class="highlight"></span>
                                                                <span class="bar"></span>
                                                                <label>Name</label>

                                                        </div>
                                                        <div class="group">
                                                            <input type="number" name="phno" id="phno1"></input><span class="highlight"></span><span class="bar"></span><label>Mobile Number</label>
                                                        </div>
                                                        <div class="group">
                                                            <input type="text" name="email" id="email1"></input><span class="highlight"></span><span class="bar"></span><label>Email Address</label>
                                                        </div>
                                                        <div class="group">
                                                            <input type="text" name="desc" id="desc1"></input>
                                                                <input type="hidden" name="type" id="type" value="custom"></input><span class="highlight"></span><span class="bar"></span><label>Other Message</label>
                                                        </div>
                                                        <button onClick={this.handleSubmit} className="col-md-4 submitbutton" id="form_submit">SUBMIT</button>
                                                    </div>
                                                </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="panel panel-default">
                                    <div class="panel-heading">
                    <span class="panel-title">
                    <h3>Opportunities Analysis</h3>
                    <p>The second biggest player has acquired 3 companies, one each from Japan, India and China.How would it impact the industry dynamic
</p>
                      <a data-toggle="collapse" data-parent="#accordion" href="#collapse2" class="knowmore">Know More</a>
                    </span>
                                    </div>
                                    <div id="collapse2" class="panel-collapse collapse">
                                        <div class="panel-body">
                                            <div class="col-md-8 custo_bg">
                                                <ul class="ul_qu">
                                                    <li>  I would like to launch my product in the Asia-Pacific Market. What would be my target market size and how is its growth over the years?  	</li>
                                                    <li> In Asia-Pacific, which is the country with maximum targetabl
                                                        e market that has got least friction in terms of regulation and compliance.
                                                    </li>
                                                    <li> Is a market with healthy growth the place to be? What about competition?</li>
                                                    <li> I would like to launch my product in the Asia-Pacific Market. What would be my target market size and how is its growth over the years?  </li>
                                                    <li> In Asia-Pacific, which is the country with maximum targetable market that has got least friction in terms of regulation and compliance.
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="col-md-4 flash_sidebg">
                                                <h4>
                                                    Ask for a Proposal Today</h4>
                                                <div class="cust_form_bg">
                                                    <div class="new_form_req" id="new_custom">
                                                        <div class="group">
                                                            <input type="text" name="name" id="name2"></input>
                                                            <span class="highlight"></span>
                                                            <span class="bar"></span>
                                                            <label>Name</label>

                                                        </div>
                                                        <div class="group">
                                                            <input type="number" name="phno" id="phno2"></input><span class="highlight"></span><span class="bar"></span><label>Mobile Number</label>
                                                        </div>
                                                        <div class="group">
                                                            <input type="text" name="email" id="email2"></input><span class="highlight"></span><span class="bar"></span><label>Email Address</label>
                                                        </div>
                                                        <div class="group"><input type="text" name="desc2" id="desc2"></input>
                                                            <input type="hidden" name="type" id="type" value="custom"></input><span class="highlight"></span><span class="bar"></span><label>Other Message</label>
                                                        </div>
                                                        <button onClick={this.handleSubmit2} className="col-md-4 submitbutton" id="form_submit">SUBMIT</button>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="panel panel-default">
                                    <div class="panel-heading">
                    <span class="panel-title">
                    <h3>Market Dynamics</h3>
                    <p>The second biggest player has acquired 3 companies, one each from Japan, India and China. How would it impact the industry dynamic
</p>
                      <a data-toggle="collapse" data-parent="#accordion" href="#collapse3" class="knowmore">Know More</a>
                    </span>
                                    </div>
                                    <div id="collapse3" class="panel-collapse collapse">
                                        <div class="panel-body">
                                            <div class="col-md-8 custo_bg">
                                                <ul class="ul_qu">
                                                    <li>  I would like to launch my product in the Asia-Pacific Market. What would be my target market size and how is its growth over the years?  	</li>
                                                    <li> In Asia-Pacific, which is the country with maximum targetabl
                                                        e market that has got least friction in terms of regulation and compliance.
                                                    </li>
                                                    <li> Is a market with healthy growth the place to be? What about competition?</li>
                                                    <li> I would like to launch my product in the Asia-Pacific Market. What would be my target market size and how is its growth over the years?  </li>
                                                    <li> In Asia-Pacific, which is the country with maximum targetable market that has got least friction in terms of regulation and compliance.
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="col-md-4 flash_sidebg">
                                                <h4>
                                                    Ask for a Proposal Today</h4>
                                                <div class="cust_form_bg">
                                                    <div class="new_form_req" id="new_custom">
                                                        <div class="group">
                                                            <input type="text" name="name" id="name3"></input>
                                                            <span class="highlight"></span>
                                                            <span class="bar"></span>
                                                            <label>Name</label>

                                                        </div>
                                                        <div class="group">
                                                            <input type="number" name="phno" id="phno3"></input><span class="highlight"></span><span class="bar"></span><label>Mobile Number</label>
                                                        </div>
                                                        <div class="group">
                                                            <input type="text" name="email" id="email3"></input><span class="highlight"></span><span class="bar"></span><label>Email Address</label>
                                                        </div>
                                                        <div class="group"><input type="text" name="desc3" id="desc3"></input>
                                                            <input type="hidden" name="type" id="type" value="custom"></input><span class="highlight"></span><span class="bar"></span><label>Other Message</label>
                                                        </div>
                                                        <button onClick={this.handleSubmit3} className="col-md-4 submitbutton" id="form_submit">SUBMIT</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <NotificationContainer />
                                        </div>
                                    </div>
                                </div>

                                <div class="panel panel-default">
                                    <div class="panel-heading">
                    <span class="panel-title">
                    <h3>Competitive Intelligence</h3>
                    <p>The second biggest player has acquired 3 companies, one each from Japan, India and China.How would it impact the industry dynamic
</p>
                      <a data-toggle="collapse" data-parent="#accordion" href="#collapse4" class="knowmore">Know More</a>
                    </span>
                                    </div>
                                    <div id="collapse4" class="panel-collapse collapse">
                                        <div class="panel-body">
                                            <div class="col-md-8 custo_bg">
                                                <ul class="ul_qu">
                                                    <li>  I would like to launch my product in the Asia-Pacific Market. What would be my target market size and how is its growth over the years?  	</li>
                                                    <li> In Asia-Pacific, which is the country with maximum targetabl
                                                        e market that has got least friction in terms of regulation and compliance.
                                                    </li>
                                                    <li> Is a market with healthy growth the place to be? What about competition?</li>
                                                    <li> I would like to launch my product in the Asia-Pacific Market. What would be my target market size and how is its growth over the years?  </li>
                                                    <li> In Asia-Pacific, which is the country with maximum targetable market that has got least friction in terms of regulation and compliance.
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="col-md-4 flash_sidebg">
                                                <h4>
                                                    Ask for a Proposal Today</h4>
                                                <div class="cust_form_bg">
                                                    <div class="new_form_req" id="new_custom">
                                                        <div class="group">
                                                            <input type="text" name="name" id="name4"></input>
                                                            <span class="highlight"></span>
                                                            <span class="bar"></span>
                                                            <label>Name</label>

                                                        </div>
                                                        <div class="group">
                                                            <input type="number" name="phno" id="phno4"></input><span class="highlight"></span><span class="bar"></span><label>Mobile Number</label>
                                                        </div>
                                                        <div class="group">
                                                            <input type="text" name="email" id="email4"></input><span class="highlight"></span><span class="bar"></span><label>Email Address</label>
                                                        </div>
                                                        <div class="group"><input type="text" name="desc" id="desc4"></input>
                                                            <input type="hidden" name="type" id="type" value="custom"></input><span class="highlight"></span><span class="bar"></span><label>Other Message</label>
                                                        </div>
                                                        <button onClick={this.handleSubmit4} className="col-md-4 submitbutton" id="form_submit">SUBMIT</button>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>


                            </div>

                        </div>

                        </div></div>
                </section>

            </div>

        );
    }


    handleSubmit() {

        var name = $("#name1").val();
        var email = $("#email1").val();
        var phone = $("#phno1").val();
        var description = $("#desc1").val();
        if (email == '') {

            NotificationManager.error('Error', 'Please enter Correct Email !', 5000);
            return false;
        }
        else if (description == '') {
            NotificationManager.error('Error', 'Please enter what you are looking for!', 5000);
            return false;
        }
        else if (phone < 1) {
            NotificationManager.error('Error', 'Please enter a valid phone number!', 5000);
            return false;
        }
        else if (email != '' && description != '' && phone!='' && name!='') {


            var atpos =  email.indexOf("@");
            var dotpos =  email.lastIndexOf(".");
            if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= email.length) {

                NotificationManager.error('Error', 'Enter valid email id!', 5000);
                return false;
            }
            else {
                var postData =
                    {
                        name: name,
                        email: email,
                        phno: phone,
                        desc: description,
                        custom_user_session_id: localStorage.getItem('SessionID')
                    }


                $.ajax({
                    type: 'POST',
                    url: API_Config.http_url + API_Config.end_point.contactUs,
                    data:postData
                })
                    .done(function (data) {
                        NotificationManager.success('Success', 'Proposal accepted successfully', 5000);
                        $("#name1").val('')
                        $("#email1").val('');
                        $("#phno1").val('');
                        $("#desc1").val('');

                    })
                    .fail(function (jqXhr) {
                        NotificationManager.error('Error', 'Something went wrong!', 5000);
                    });


            }

        }

        else{
            NotificationManager.error('Error', 'Please enter the details!', 5000);
            return false;
        }


    }

    handleSubmit2() {

        var name = $("#name2").val();
        var email = $("#email2").val();
        var phone = $("#phno2").val();
        var description = $("#desc2").val();
        if (email == '') {

            NotificationManager.error('Error', 'Please enter Correct Email !', 5000);
            return false;
        }
        else if (description == '') {
            NotificationManager.error('Error', 'Please enter what you are looking for!', 5000);
            return false;
        }
        else if (phone < 1) {
            NotificationManager.error('Error', 'Please enter a valid phone number!', 5000);
            return false;
        }
        else if (email != '' && description != '' && phone!='' && name!='') {


            var atpos =  email.indexOf("@");
            var dotpos =  email.lastIndexOf(".");
            if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= email.length) {

                NotificationManager.error('Error', 'Enter valid email id!', 5000);
                return false;
            }
            else {
                var postData =
                    {
                        name: name,
                        email: email,
                        phno: phone,
                        desc: description,
                        custom_user_session_id: localStorage.getItem('SessionID')
                    }


                $.ajax({
                    type: 'POST',
                    url: API_Config.http_url + API_Config.end_point.contactUs,
                    data:postData
                })
                    .done(function (data) {
                        NotificationManager.success('Success', 'Proposal accepted successfully', 5000);
                        $("#name2").val('')
                        $("#email2").val('');
                        $("#phno2").val('');
                        $("#desc2").val('');

                    })
                    .fail(function (jqXhr) {
                        NotificationManager.error('Error', 'Something went wrong!', 5000);
                    });


            }

        }

        else{
            NotificationManager.error('Error', 'Please enter the details!', 5000);
            return false;
        }


    }

    handleSubmit3() {

        var name = $("#name3").val();
        var email = $("#email3").val();
        var phone = $("#phno3").val();
        var description = $("#desc3").val();
        if (email == '') {

            NotificationManager.error('Error', 'Please enter Correct Email !', 5000);
            return false;
        }
        else if (description == '') {
            NotificationManager.error('Error', 'Please enter what you are looking for!', 5000);
            return false;
        }
        else if (phone < 1) {
            NotificationManager.error('Error', 'Please enter a valid phone number!', 5000);
            return false;
        }
        else if (email != '' && description != '' && phone!='' && name!='') {

            var atpos =  email.indexOf("@");
            var dotpos =  email.lastIndexOf(".");
            if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= email.length) {

                NotificationManager.error('Error', 'Enter valid email id!', 5000);
                return false;
            }
            else {
                var postData =
                    {
                        name: name,
                        email: email,
                        phno: phone,
                        desc: description,
                        custom_user_session_id: localStorage.getItem('SessionID')
                    }


                $.ajax({
                    type: 'POST',
                    url: API_Config.http_url + API_Config.end_point.contactUs,
                    data:postData
                })
                    .done(function (data) {
                        NotificationManager.success('Success', 'Proposal accepted successfully', 5000);
                        $("#name3").val('')
                        $("#email3").val('');
                        $("#phno3").val('');
                        $("#desc3").val('');

                    })
                    .fail(function (jqXhr) {
                        NotificationManager.error('Error', 'Something went wrong!', 5000);
                    });


            }

        }

        else{
            NotificationManager.error('Error', 'Please enter the details!', 5000);
            return false;
        }


    }

    handleSubmit4() {

        var name = $("#name4").val();
        var email = $("#email4").val();
        var phone = $("#phno4").val();
        var description = $("#desc4").val();
        if (email == '') {
            NotificationManager.error('Error', 'Please enter Correct Email !', 5000);
            return false;
        }
        else if (description == '') {
            NotificationManager.error('Error', 'Please enter what you are looking for!', 5000);
            return false;
        }
        else if (phone < 1) {
            NotificationManager.error('Error', 'Please enter a valid phone number!', 5000);
            return false;
        }
        else if (email != '' && description != '' && phone!='' && name!='') {


            var atpos =  email.indexOf("@");
            var dotpos =  email.lastIndexOf(".");
            if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= email.length) {

                NotificationManager.error('Error', 'Enter valid email id!', 5000);
                return false;
            }
            else {
                var postData =
                    {
                        name: name,
                        email: email,
                        phno: phone,
                        desc: description,
                        custom_user_session_id: localStorage.getItem('SessionID')
                    }


                $.ajax({
                    type: 'POST',
                    url: API_Config.http_url + API_Config.end_point.contactUs,
                    data:postData
                })
                    .done(function (data) {
                        NotificationManager.success('Success', 'Proposal accepted successfully', 5000);
                        $("#name4").val('')
                        $("#email4").val('');
                        $("#phno4").val('');
                        $("#desc4").val('');


                    })
                    .fail(function (jqXhr) {
                        NotificationManager.error('Error', 'Something went wrong!', 5000);
                    });


            }

        }

        else{
            NotificationManager.error('Error', 'Please enter the details!', 5000);
            return false;
        }


    }


}
export default CustomResearch;


// WEBPACK FOOTER //
// ./src/consulting/CustomResearch/CustomResearch.js